import { kebabCase } from 'lodash/fp';
import { Interval } from 'luxon';

import { WorkflowErrorType, WorkflowRunError } from 'dashboard/models/workflow';
import { WorkflowRunStep } from 'dashboard/models/workflow-step';
import { WorkflowRunStepErrorType } from 'dashboard/models/workflow-version';

export const getWorkflowRunStepErrors = (steps: WorkflowRunStep[]): WorkflowRunError[] => {
  const generateKebabCasedDotNotation = (input: string) =>
    input.split('.').map(kebabCase).join('.');

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  return steps
    .filter((step) =>
      [
        WorkflowRunStepErrorType.InvalidStepConfigError,
        WorkflowRunStepErrorType.UnexpectedParameterError,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      ].includes(step?.attributes?.['step-error']?.type),
    )
    .map(({ attributes: { 'config-step-token': token, 'step-error': stepError } }) => {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      if (stepError.type === WorkflowRunStepErrorType.InvalidStepConfigError) {
        const {
          message,
          attributes: { 'errored-field': erroredField, 'errored-fields': erroredFields },
        } = stepError;

        return {
          type: WorkflowErrorType.Run,
          token,
          message,
          ...(erroredField ? { fields: [generateKebabCasedDotNotation(erroredField)] } : {}),
          ...(erroredFields ? { fields: erroredFields.map(generateKebabCasedDotNotation) } : {}),
        };
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      } else if (stepError.type === WorkflowRunStepErrorType.UnexpectedParameterError) {
        const {
          message,
          attributes: { 'field-errors': fieldErrors },
        } = stepError;

        return {
          type: WorkflowErrorType.Run,
          token,
          message,
          fields: (fieldErrors || []).map((fieldError) => fieldError.name),
        };
      }
    });
};

// Given a small interval (segment) and big interval (total), returns
// - the fraction (expressed in decimal) of the total interval before the segment starts
// - the fraction (expressed in decimal) of the total interval the segment spans
export const intervalPercentile = (
  segment: Interval,
  total: Interval,
): {
  startFraction: number;
  spanFraction: number;
} => {
  if (segment.start && segment.isValid && total.start && total.isValid && total.engulfs(segment)) {
    const totalMs = total.length('milliseconds');
    const spanMs = segment.length('milliseconds');
    const startMs = Interval.fromDateTimes(total.start, segment.start).length('milliseconds');

    return {
      startFraction: startMs / totalMs,
      spanFraction: spanMs / totalMs,
    };
  }

  return { startFraction: NaN, spanFraction: NaN };
};
